import AddIcon from '@mui/icons-material/Add';
import Box from '@mui/material/Box';
import React from 'react';

import ProceedButton from '../../../ProceedButton';
import { PrivateRoutePath } from '../../../../utils/routes';

export interface OrderButtonProps {
  disabled?: boolean;
  onClick: () => void;
  buttonClasses?: string;
  buttonTextClasses?: string;
}

//  TODO: remove app context in favour of url state and make this button a link
function OrderButton({ onClick, buttonClasses, buttonTextClasses, disabled }: OrderButtonProps) {
  return (
    <Box width="100%" boxSizing="border-box" display="flex" justifyContent="center">
      <ProceedButton
        href={PrivateRoutePath.NEW_ORDER}
        disabled={disabled}
        variant="contained"
        onClick={onClick}
        className={buttonClasses}
        startIcon={<AddIcon />}
        size="medium"
      >
        <span className={buttonTextClasses}>Order now</span>
      </ProceedButton>
    </Box>
  );
}
export default OrderButton;
